import { render, staticRenderFns } from "./AiChatSidebar.vue?vue&type=template&id=402781b5&lang=pug"
import script from "./AiChatSidebar.vue?vue&type=script&lang=js"
export * from "./AiChatSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports